"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Just_1 = require("./Just");

exports.Just = Just_1.default;
exports.just = Just_1.just;

var Maybe_1 = require("./Maybe");

exports.Maybe = Maybe_1.default;

var Nothing_1 = require("./Nothing");

exports.Nothing = Nothing_1.default;
exports.nothing = Nothing_1.nothing;
/**
 * Converts a value that _may_ be null or undefined to a maybe.
 * If the value is null or undefined, then Nothing is returned.
 * If the value is anything else, it is returned wrapped in a Just.
 */

var fromNullable = function fromNullable(v) {
  if (v) {
    return Just_1.just(v);
  }

  return Nothing_1.nothing();
};

exports.fromNullable = fromNullable;
/**
 * Converts a value that _may_ be empty, such as a string or an array, to a
 * maybe. It will accept anything that responds to length.
 * If the value is has a length of 0, then Nothing is returned.
 * If the value is anything else, it is returned wrapped in a Just.
 */

var fromEmpty = function fromEmpty(xs) {
  return xs.length === 0 ? Nothing_1.nothing() : Just_1.just(xs);
};

exports.fromEmpty = fromEmpty;
/**
 * Returns true if maybe is an instance of Just
 *
 * Example: Remove `Nothing` values from an array
 *
 *     const maybes: Maybe<string>[]
 *     maybes.filter(isJust)
 */

var isJust = function isJust(maybe) {
  return maybe instanceof Just_1.default;
};

exports.isJust = isJust;
/**
 * Returns true if maybe is an instance of Nothing
 *
 * Example: Count the `Nothing`s
 *
 *     const maybes: Maybe<string>[];
 *     maybes.filter(isNothing).length;
 */

var isNothing = function isNothing(maybe) {
  return maybe instanceof Nothing_1.default;
};

exports.isNothing = isNothing;